module.exports = __webpack_public_path__ + "files/5ffe0b6625c30da07ab64bcd8005e637.png";